export const dashboardStyle = ` <style>
  main .dashboard-individual {
    margin-top: 20px;
    padding: 0;
  }

  main .dashboard-individual .dashboard-individual-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #343333;
    padding-top: 15px;
    height: 80px;
  }

  main .dashboard-individual .dashboard-individual-header img {
    width: 50px;
    height: 50px;
    margin-left: 50px;
  }

  main .dashboard-individual .dashboard-individual-header .download-btn {
    margin-left: 0;
    width: 191px;
    height: 50px;
    font-size: 16px;
    font-weight: 700;
    line-height: 19.2px;
    white-space: nowrap;
  }

  main .dashboard-individual .dashboard-individual-header .download-btn img {
    margin-left: 0;
    width: 33px;
    height: 33px;
  }

  main .dashboard-individual .dashboard-individual-header .individual-name {
    padding-left: 66px;
    text-transform: capitalize;
  }

  main .dashboard-individual .dashboard-individual-header .individual-name h1 {
    font-size: 24px;
    line-height: 36px;
    font-weight: 600;
    margin: 0;
    text-transform: capitalize;
  }

  main .dashboard-individual .dashboard-individual-header .individual-name p {
    font-size: 18px;
    line-height: 27px;
    font-weight: 400;
    text-align: center;
    margin: -8px 0 0;
    color: #00000066;
    text-transform: capitalize;

  }

  main .dashboard-individual h2 {
    text-align: center;
    margin: 0 auto 35px;
    font-size: 21px;
    font-weight: 700;
    line-height: 31.2px;
  }

  main .dashboard-individual .individual-date {
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 92%;
    margin: 0 auto;
  }

  main .dashboard-individual .individual-date p {
    font-size: 16px;
    line-height: 35px;
    margin: 6px 0 20px;
  }

  main .dashboard-individual .individual-date p span {
    font-size: 18px;
    line-height: 21.6px;
    font-weight: 700;
  }

  main .dashboard-individual .individual-info {
    display: flex;
    justify-content: space-around;
    background-color: #F8FCF9;
    border-radius: 15px;
    box-shadow: 0 0 1px;
    max-width: 92%;
    margin: 0 auto;
    padding: 10px 0;
  }

  main .dashboard-individual .individual-info .customer-detail {
    display: flex;
    align-items: center;
  }

  main .dashboard-individual .individual-info .customer-detail .coln {
    font-weight: 700;
    font-size: 18px;
    line-height: 21.6px;
    margin: 8px 0;
    width: 150px;
  }

  main .dashboard-individual .individual-info .customer-detail .detail {
    font-size: 18px;
    font-weight: 400;
    line-height: 21.6px;
    margin: 8px 0;
  }

  main .dashboard-individual .individual-info .group-2 .coln {
    width: 180px;
  }

  main .dashboard-individual .category {
    max-width: 92%;
    margin: 0 auto;
    border-radius: 2px;
    padding-bottom: 60px;
  }

  main .dashboard-individual .category h2 {
    margin: 70px auto 25px;
  }

  main .dashboard-individual .category .response-answer {
    border: 2px solid #D8D8D8;
    box-shadow: 0px 4px 4px 0px #00000040;
    border-radius: 12px;
  }

  main .dashboard-individual .category .response-answer .category-header {
    display: flex;
    align-items: center;
    background-color: #3FA554;
  }

  main .dashboard-individual .category .response-answer .category-header .tab {
    padding-top: 8px;
    width: 180px;
    margin: 0;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #343333;
    font-size: 18px;
    font-weight: 400;
    line-height: 19.8px;
    padding-top: 18px;
    border: 'none'
  }

  .individual-date {
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 92%;
    margin: 0 auto;
  }

  .individual-date p span {
    font-size: 18px;
    line-height: 21.6px;
    font-weight: 700;
  }

  .individual-date p {
    font-size: 400;
    font-size: 16px;
    line-height: 35px;
    margin: 6px 0 20px;
  }

  .dashboard-individual-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #343333;
    padding-top: 15px;
    height: 80px;
  }

  .individual-name {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 70%;
  }

  .individual-name p {
    margin: -22px 0 0;
    color: rgba(0, 0, 0, 0.4);
  }

  .personal-detail {
    text-align: center;
    width: 100vw;
  }

  .detail {
    font-size: 18px;
    font-weight: 400;
    line-height: 21.6px;
    margin: 8px 0;
    text-transform: capitalize;
  }

  .lower-case {
    text-transform: lowercase;
  }

  .coln {
    font-weight: 700;
    font-size: 18px;
    line-height: 21.6px;
    margin: 8px 0;
    width: 150px;
  }

  .individual-info {
    display: flex;
    justify-content: space-around;
    background-color: #F8FCF9;
    border-radius: 15px;
    border: 1px solid #ced1cf;
    max-width: 92%;
    margin: 0 auto;
    padding: 10px 0;
  }

  .customer-detail {
    display: flex;
    align-items: center;
  }

  .responses-per-caty {
    margin: 70px auto 25px;
    text-align: center;
  }

  .category {
    max-width: 92%;
    margin: 0 auto;
    border-radius: 2px;
    padding-bottom: 60px;
  }

  .response-answer {
    border: 2px solid #D8D8D8;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.2509803922);
    border-radius: 12px;
  }

  .category-header {
    display: none;
  }

  .tab {
    padding-top: 8px;
    width: 180px;
    margin: 0;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #343333 !important;
    font-size: 18px;
    font-weight: 400;
    line-height: 19.8px;
    padding-top: 18px;
    border: none;
  }

  .active {
    background-color: #3FA554 !important;
    border-radius: 6px 6px 0 0 !important;
    color: #ffffff !important;
    font-weight: 700 !important;
    display: flex !important;
    border: none
  }

  .category-body {
    border: 2px solid #3FA554;
    border-radius: 0 8px 8px 8px;
    background-color: #F8FCF9;
    padding: 16px 0;
  }

  .header-only-pdf { 
    display: block; 
    text-align: center;
    margin: 40px;
  }

  .question-box {
    max-width: 95%;
    margin: 8px auto;
    display:block !important;
  }

  .question {
    display: flex;
    justify-content: space-between;
    background-color: #343333;
    border-radius: 3px 3px 0 0;
  }

  .question h4 {
    padding: 9px 0 9px 20px;
    color: #ffffff;
    line-height: 31px;
    font-size: 16px;
    font-weight: 700;
    margin: 0;
  }

  .answer span {
    font-weight: 700;
  }

  .answer p {
    color: #100F2E;
    font-size: 16px;
    line-height: 31px;
    font-weight: 400;
    max-width: 95%;
    margin: 0 auto;
    padding-top: 20px;
  }

  .answer {
    display:block !important;
    background-color: #ffffff;
  }

  .group-1 {
    margin-left: 35px;
  }

  .group-2 {
    margin-left: 35px;
  }

  .question button {
    background-color: #343333;
    border: none
    box-shadow: none;
  }

  .back-btn {
    background-color: unset;
    border: none
  }

  .download-btn {
    display: flex;
    align-self: center;
    margin-left: auto;
    background-color: #3FA554;
    border-radius: 10px;
    padding: 0.5rem;
    box-shadow: none;
    font-weight: 700;
    font-family: "Lato", sans-serif;
    width: 100%;
    height: 50px;
    font-size: 16px;
    font-weight: 700;
    line-height: 19.2px;
    border: none;
    color: #FFFFFF; 
    align-items: center;
    margin-right: 17px;

  }
  .back-btn, .download-btn {
    visibility: hidden;

  }
</style>`